import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { token, user, userAgencyObject } from "../../../modules/auth";
import {
  fetchSnapshotAnnualReport,
  unloadSnapshotAnnualReport,
} from "../../../redux/actions";
import Loading from "../../Loading";
import { ToggleReportType } from "../../reports/ToggleReportType";
import { ToggleReportDateFilter } from "../../reports/ToggleReportDateFilter";
import SnapshotLineChart from "./SnapshotLineChart";
import { ToggleMetricSelector } from "../../reports/agency/ToggleSnapshotMetrics";

const EVENT_DATE_FILTER = "event_date_from";
const CREATED_AT_FILTER = "created_at";
const FINANCIAL_YEAR = "financial";
const CALENDAR_YEAR = "calendarYear";

function AgencySnapshotDashChart({
  isFetchingSnapshotAnnualReport,
  snapshotAnnualReport,
  fetchSnapshotAnnualReport,
  token,
  unloadSnapshotAnnualReport,
  agencies,
}) {
  const [metric, setMetric] = useState("event_count");
  const [metricFilter, setMetricFilter] = useState("all");
  const [dateFilter, setDateFilter] = useState(EVENT_DATE_FILTER);
  const [reportType, setReportType] = useState(CALENDAR_YEAR);
  const agencyIds = useMemo(() => agencies?.map(a => a.id).join(","), [
    agencies,
  ]);

  useEffect(() => {
    return () => {
      unloadSnapshotAnnualReport();
    };
  }, []);

  useEffect(() => {
    if (agencyIds) {
      const queryParams = {
        dateColumn: dateFilter,
        agency: agencyIds,
        filter: metricFilter,
      };
      if (reportType === "financial") queryParams.reportType = reportType;
      fetchSnapshotAnnualReport(token, queryParams);
    }
  }, [dateFilter, reportType, agencyIds, metricFilter]);

  return (
    <div key={`agencySnapshotDashboardChart-${agencies.length}`}>
      <div className="mb-4">
        <div className="flex flex-col md:flex-row items-start justify-between mb-4">
          <h2 className="text-2xl font-bold">Year to date</h2>

          <div className="text-right">
            {agencies && agencies.length === 1 && (
              <div className="inline-block mr-2">
                <ToggleReportType
                  reportType={reportType}
                  financialYearOnClick={() => setReportType(FINANCIAL_YEAR)}
                  calendarYearOnClick={() => setReportType(CALENDAR_YEAR)}
                />
              </div>
            )}
            <div className="inline-block">
              <ToggleReportDateFilter
                dateFilter={dateFilter}
                createdAtOnClick={() => setDateFilter(CREATED_AT_FILTER)}
                eventDateOnClick={() => setDateFilter(EVENT_DATE_FILTER)}
                EVENT_DATE_FILTER={EVENT_DATE_FILTER}
                CREATED_AT_FILTER={CREATED_AT_FILTER}
              />
            </div>
          </div>
        </div>
      </div>

      {isFetchingSnapshotAnnualReport ? (
        <div className="relative" style={{ height: 500 }}>
          <div
            className="absolute pin"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loading />
          </div>
        </div>
      ) : (
        <SnapshotLineChart
          metric={metric}
          snapshotData={snapshotAnnualReport}
        />
      )}

      <div className="mt-12">
        <ToggleMetricSelector
          selectedMetric={metric}
          onChange={setMetric}
          setFilter={setMetricFilter}
        />
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    selectedAgencies: state.selectedAgencies,
    ...state.snapshotAnnualReport,
    user: user(state),
    agency: userAgencyObject(state),
    token: token(state),
  };
};

const mapDispatchToProps = {
  fetchSnapshotAnnualReport,
  unloadSnapshotAnnualReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgencySnapshotDashChart);
